<template>
  <div id="app">
    <Navigation v-if="$store.getters.isAuthenticated && $store.getters.isNavigationBarVisible"/>
    <main role="main">
      <global-loading-screen></global-loading-screen>
      <div v-if="$store.getters.isAuthenticated">
        <b-alert v-model="hasError" variant="danger" dismissible>
          {{ this.errorMessage }}
        </b-alert>
      </div>
      <router-view/>
    </main>
  </div>
</template>
<script>
import Navigation from './components/Navigation'
import GlobalLoadingScreen from './components/GlobalLoadingScreen'
import {mapState} from 'vuex'

export default {
  name: 'App',
  components: {Navigation, GlobalLoadingScreen},
  computed: {
    hasError: {
      get () { return this.$store.state.hasError },
      set (value) { this.$store.commit('clearError') }
    },
    ...mapState({
      errorMessage: state => state.errorMessage
    })
  }
}
</script>

<style>
html, body{
  font-family: 'Oswald', sans-serif;
  background-color: #1B2736;
  height: 100%;

}
@media print {
  html, body{
    background-color: #fff;
  }
}
#app {}
.col-card{
  background-color: #f2f2f2;
}
.card{
  border-radius: 0;
  border: 0;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1);

}
.card-header, .card-footer{
  color: #aaa;
  background: #fff;
}
.card-footer{
  text-align: right;
}
.full-page{
  height: 100vh;
}
.quad-box{
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1);
  color: #fff;
}
.quad-box h1{
  font-weight: 300;
}
.quad-box p{
  line-height: 0.25;
}
.detail-box {
  color: #fff
}
.detail-box a {
  color: #fff
}
.ma-card{
  font-weight: 300;
  text-transform: uppercase;
  background-color: #FFFFFF;
}
.ma-card h1{
  font-size: 2em;
  color: #BE1E2D;
}
.ma-card > .title{
  font-size: 1.25em;
  font-weight: 500;
}
.maadi-dark-card {
  background: #243447;
  color: #FFFFFF
}

.maadi-dark-card input, .maadi-dark-card select, .maadi-dark-card .dropdown{
  border-radius: 0;
}
.maadi-dark-card .col-form-label {
  color: #FFFFFF;
  font-weight: 300;
  font-size: 0.9em;

}
.maadi-dark-card a {
  color: #FFFFFF
}
.maadi-dark-card .card-header {
  background: #243447;
  font-weight: 300;
  color: #ffffff;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.badge-maadi {
  background: #3E597A;
  color: #FFFFFF;
  font-weight: 500;
  padding: 5px;
}
.maadi-button {
  background: #03B5AA;
  color: #FFFFFF;
  font-weight: 300;
  border-radius: 0;
}
.modal-body, .modal-header, .maadi-row {
  background: #3E597A;
  color:#ffffff
}
.maadi-inlay {
  background: #3E597A;
}
.modal-body table {
  background: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/App.vue